import React from 'react';
import TextField from '@mui/material/TextField';

import { validatePhoneNumber } from 'src/common/phone-number-utils';

import styles from 'src/components/edit-contacts-modal/EditContactsModal.module.css';

const EMAIL_PATTERN = /^\S+@\S+\.\S+$/;

export interface IContactFieldsState {
    name: string;
    email: string;
    phoneNumber: string;
}

export const EMPTY_CONTACT_FIELDS: IContactFieldsState = {
    name: '',
    email: '',
    phoneNumber: '',
};

/** The phone number is optional, so an empty value is valid. */
export function isPhoneNumberValid(phoneNumber: string): boolean {
    return validatePhoneNumber(phoneNumber.trim()) === true;
}

export function areContactFieldsValid(fields: IContactFieldsState): boolean {
    return EMAIL_PATTERN.test(fields.email.trim()) && isPhoneNumberValid(fields.phoneNumber);
}

interface IContactFieldsProps {
    fields: IContactFieldsState;
    setFields(fields: IContactFieldsState): void;
}

export function ContactFields({ fields, setFields }: IContactFieldsProps) {
    return (
        <div className={styles.contactFields}>
            <TextField
                autoFocus
                required
                placeholder="Email"
                type="email"
                value={fields.email}
                onChange={(event) => setFields({ ...fields, email: event.target.value })}
                fullWidth
                variant="standard"
                margin="dense"
                data-testid="contact-email-field"
            />
            <TextField
                placeholder="Name (optional)"
                value={fields.name}
                onChange={(event) => setFields({ ...fields, name: event.target.value })}
                fullWidth
                variant="standard"
                margin="dense"
                // reflects backend limit
                inputProps={{ maxLength: 60 }}
                data-testid="contact-name-field"
            />
            <TextField
                placeholder="Phone Number (optional)"
                type="tel"
                value={fields.phoneNumber}
                onChange={(event) => setFields({ ...fields, phoneNumber: event.target.value })}
                fullWidth
                variant="standard"
                margin="dense"
                error={!isPhoneNumberValid(fields.phoneNumber)}
                helperText={
                    isPhoneNumberValid(fields.phoneNumber) ? undefined : 'Enter a valid phone number'
                }
                data-testid="contact-phone-field"
            />
        </div>
    );
}
